<template>
  <div class="view user-center-view">
    <HeaderBar>
      <img
        v-if="!is_takecare"
        class="fav-img"
        src="../../assets/images/unlike.png"
        alt="收藏"
        @click="onLikeClick"
      />
      <img
        v-else
        class="fav-img"
        src="../../assets/images/like.png"
        alt="取消收藏"
        @click="onDislikeClick"
      />
    </HeaderBar>
    <NameCard :userInfo="userInfo" />
    <van-tabs v-model="active" @change="onActiveChange" swipeable>
      <van-tab title="文章">
        <div class="news-list list">
          <NewsItem v-for="item in newsList" :key="item.id" v-bind="item" />
        </div>
      </van-tab>
      <van-tab title="智库">
        <div class="digital-list list">
          <DigitalItem
            v-for="item in digitalList"
            :key="item.id"
            v-bind="item"
          />
        </div>
      </van-tab>
      <van-tab title="学院">
        <div class="course-list list">
          <CourseItem v-for="item in courseList" :key="item.id" v-bind="item" />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'

import { Tabs, Tab } from 'vant';
import apiUtil from '../../utils/apiUtil';
import apiConst from '../../consts/apiConst';
import HeaderBar from '../../components/HeaderBar';
import NameCard from '../../components/NameCard';
import NewsItem from '../../components/NewsItem';
import DigitalItem from '../../components/DigitalItem';
import CourseItem from '../../components/CourseItem';

export default {
  name: 'userCenter',
  components: {
    'van-tabs': Tabs,
    'van-tab': Tab,
    NewsItem,
    DigitalItem,
    CourseItem,
    HeaderBar,
    NameCard
  },
  data() {
    return {
      newsList: [],
      digitalList: [],
      courseList: [],
      active: 0,
      type: 1,
      suffix: 1,
      userInfo: {},
      is_takecare: 0,

      pagesize: 10
    };
  },
  created() {
    const { action_id, is_admin_publish } = this.$route.query;
    this.userInfo = {
      action_id,
      is_admin_publish
    };
    this.getPublished();
    this.getUserInfo();
  },
  methods: {
    async getPublished(page = 1, type = 1, suffix = 0) {
      const res = await apiUtil.post(apiConst.getUserPublished, {
        page,
        pagesize: this.pagesize,
        type,
        suffix,
        ...this.userInfo
      });
      if (res.success) {
        if (type === 1) {
          this.newsList = res.list;
        } else if (type === 2) {
          this.digitalList = res.list;
        } else if (type === 3) {
          this.courseList = res.list;
        } else return;
      }
    },

    async getUserInfo(a) {
      const res = await apiUtil.post(apiConst.getUserInfo, {
        ...this.userInfo
      });
      if (res) {
        const { is_takecare } = res;
        this.is_takecare = is_takecare;
      }
    },

    async onLikeClick() {
      const res = await apiUtil.post(apiConst.submitFollow, {
        type: 0,
        ...this.userInfo
      });
      if (res.success) {
        this.is_takecare = 1;
        Toast({
          message: '已关注',
          duration: 1000,
          background: '#8FC31E'
        });
      }
    },

    async onDislikeClick() {
      const res = await apiUtil.post(apiConst.submitFollow, {
        type: 1,
        ...this.userInfo
      });
      if (res.success) {
        this.is_takecare = 0;
        Toast({
          message: '已取消关注',
          duration: 1000,
          background: '#8FC31E'
        });
      }
    },

    onActiveChange(index, title) {
      this.getPublished(this.page, index + 1, this.suffix);
    }
  }
};
</script>
<style lang="stylus" scoped>
.user-center-view {
	.name-card-comp {
    margin: 22px auto;
  }

	.list {
		padding: 15px
		.course-item-comp {
			margin: 15px;
		}
    .digital-item-comp {
      margin: 15px;
    }
	}
}
</style>
